import React, {useState} from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import { SUP } from './sign_up.styled'
import logo from './assets/custom.webp'
import {z, ZodError} from 'zod'
import {postRequest} from '../http'
import {Link, useNavigate} from 'react-router-dom'
import axios from 'axios'
import Alert from 'react-bootstrap/Alert'

export default function SignUp() {
  
  
  const [center, setCenter] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [pass, setPass] = useState('')
  
  const [errors, setErrors] = useState('')
  const keys = Object.keys(errors)
  const navigate = useNavigate()
  const [token, setToken] = useState('')
  const [show, setShow] = useState(false);
  const [response, setResponse] = useState('')
  
  const onSubmit = ()=> {
    
    
    const valid = z.object({
      
      center: z.string().min(3, {message: 'Required'}),
      email: z.string().email(),
      phone: z.string().min(3, {message: 'Required'}),
      pass: z.string().min(3, {message: 'Required'}),
      
    })
    try {
      valid.parse({
        
        center:  center,
        email:  email,
        phone:  phone,
        pass: pass,
       
      })
      setErrors({err: 'none'})
      const data = {
        
        name:  center,
        email:  email,
        phone:  phone,
        pass: pass,
        token: token
      }
      
      postRequest('/sign-up', data, (res)=>{
        console.log(res)
        if (res.data.success) {
         navigate('/sign-in')
        }else{
         setResponse(res.data.message )
         setShow(true)
        }})
      
    } catch (error) {
      if (error instanceof ZodError){
        setErrors(error.flatten().fieldErrors)
      }else{
        
        setErrors({error: error.message})
      }
    }
   
  }
 

  
  return (
    <div>
      <SUP>
      
      <div className="form-head">
        <div>
        <img src={logo} height={'100px'} alt="" />
        <h3>Sign Up</h3>
        </div>
      </div>
      <div className="al-wrap">
      {show && <Alert className='alert' variant="danger" onClose={() => setShow(false)} dismissible>
       
        <p>
        {response}
        </p>
      </Alert>}
      </div>
      <div className="form-wrap">
      <div className="form">
      
      <div>
        <Form.Label>Business Name</Form.Label> 
        <Form.Control
        type='text'
        isInvalid={keys.includes('center')}
        isValid={keys.length === 0 ? false :!keys.includes('center')}
        value={center}
        onChange={(e)=>setCenter(e.target.value)}
        >
        </Form.Control>
        <Form.Control.Feedback className='err' type='invalid'>{errors?.center?.at(0)}</Form.Control.Feedback>
      </div>
    
      <div>
        <Form.Label>Phone number</Form.Label> 
        <Form.Control
        type='tel'
        isInvalid={keys.includes('phone')}
        isValid={keys.length === 0 ? false :!keys.includes('phone')}
        value={phone}
        onChange={(e)=>setPhone(e.target.value)}
        >
        </Form.Control>
        <Form.Control.Feedback className='err' type='invalid'>{errors?.phone?.at(0)}</Form.Control.Feedback>
      </div>
      <div>
        <Form.Label>Email</Form.Label> 
        <Form.Control
        type='text'
        isInvalid={keys.includes('email')}
        isValid={keys.length === 0 ? false :!keys.includes('email')}
        value={email}
        onChange={(e)=>setEmail(e.target.value)}>
        </Form.Control>
        <Form.Control.Feedback className='err' type='invalid'>{errors?.email?.at(0)}</Form.Control.Feedback>
      </div>
      <div>
        <Form.Label>Password</Form.Label> 
        <Form.Control
        type='password'
        isInvalid={keys.includes('pass')}
        isValid={keys.length === 0 ? false :!keys.includes('pass')}
        value={pass}
        onChange={(e)=>setPass(e.target.value)}>
        </Form.Control>
        <Form.Control.Feedback className='err' type='invalid'>{errors?.pass?.at(0)}</Form.Control.Feedback>
      </div>
      
      
      </div>
      </div>
      <div className="form-foot">
        <div className="btns">
        
        <Button onClick={onSubmit}><Spinner animation="grow" size="sm" /> Submit</Button>
        <Link className='self' to='/sign-in'>Have an account? Log-in</Link>
        </div>
      </div>
      </SUP>
    </div>
  )
}
